import { h, FunctionalComponent } from 'preact';
import { Tooltip, TooltipProps } from './tooltip';

interface ShortcutTooltipProps {
  primaryKey: string;
  secondaryKey: string;
}

export const ShortcutTooltip: FunctionalComponent<TooltipProps & ShortcutTooltipProps> = (
  props,
) => {
  const { primaryKey, secondaryKey, ...restProps } = props;

  return (
    <Tooltip {...restProps}>
      <div className="uwaw-main-tooltip__keys">
        <div className="uwaw-main-tooltip__key">{primaryKey}</div>
        <div className="uwaw-main-tooltip__plus">+</div>
        <div className="uwaw-main-tooltip__key">{secondaryKey}</div>
      </div>
    </Tooltip>
  );
};
